var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg24IcStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24_ic_store") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/24_ic_store",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colors/Grey",
    transform: "translate(3.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,14.016 L9,10.032 L3,10.032 L3,14.016 L9,14.016 Z M18,10.032 L17.016,10.032 L17.016,16.032 L15,16.032 L15,10.032 L11.016,10.032 L11.016,16.032 L0.984,16.032 L0.984,10.032 L0,10.032 L0,8.016 L0.984,3 L17.016,3 L18,8.016 L18,10.032 Z M17.016,0 L17.016,2.016 L0.984,2.016 L0.984,0 L17.016,0 Z",
    id: "Mask"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24IcStore);
export default __webpack_public_path__ + "static/media/24_ic_store.3d879d30.svg";
export { ForwardRef as ReactComponent };